import React, { Fragment } from "react";
function SelectGeneric({
  onChange,
  type,
  name,
  onBlur,
  value,
  errors,
  selectData,
  clave,
  disabled,
}) {
  return (
    <>
      <select
        onChange={onChange}
        value={value}
        name={name}
        onBlur={onBlur}
        disabled={disabled}
        className={`bg-transparent border ${
          (name === "banks" ||
            name === "selectCorreo" || name === "tipoMoneda" || name === "bancoReceptor" || name === "cuentaReceptor"||
            name === "accounts"|| name === "tipoTarjeta"|| name === "bancoTarjeta") &&
          "rounded-md"
        } ${
          (name === "month" || name === "year") && "rounded-r-lg"
        } rounded-l-lg ${
          errors ? "border-red-500" : "border-gray-300"
        }  text-gray-900 text-sm   focus:ring-blue-500 focus:border-blue-500  block w-full p-2.5 `}
      >
        {name === "banks" && (
          <option
            value={JSON.stringify({ nombre: "Seleccione un banco" })}
            selected
          >
            Seleccione un banco
          </option>
        )}
      
        {name === "selectCorreo" && (
          <option
            value={JSON.stringify({ nombre: "Seleccione un correo" })}
            selected
          >
            Seleccione un correo
          </option>
        )}
         

        {selectData?.map((op, index) => (
          <Fragment key={index}>
            {name === "selectCorreo" ? (
              <>
                <option
                  key={index}
                  value={
                    op?.name ||
                    JSON.stringify({ correo: op?.correo, id: op?.id }) ||
                    ""
                  }
                >
                  {op?.name || op?.nombre || op?.correo}
                </option>
              </>
            ) : (
              <>
                <option
                  key={index}
                  value={
                    op?.name ||
                    JSON.stringify({
                      nombre: op?.nombre,
                      codigo: op?.codigo,
                      rif: op?.rif,
                    }) ||
                    ""
                  }
                >
                  {op?.nombre &&
                    op?.codigo &&
                    name === "banks" + " " + "-" + " "}
                  {op?.name || op?.nombre || op?.correo}
                </option>
              </>
            )}
          
          </Fragment>
        ))}
      </select>
    </>
  );
}

export default SelectGeneric;
